import { render } from "./ReviewSearch.vue?vue&type=template&id=25e8d295&scoped=true"
import script from "./ReviewSearch.vue?vue&type=script&lang=js"
export * from "./ReviewSearch.vue?vue&type=script&lang=js"

import "./ReviewSearch.vue?vue&type=style&index=0&id=25e8d295&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e8d295"]])

export default __exports__